"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
exports.ORCHESTRATION_BASE_PATH_V3 = exports.ORCHESTRATION_BASE_PATH = exports.GeneralApiErrorCodes = void 0;
__exportStar(require("./bill/types"), exports);
__exportStar(require("./biller/types"), exports);
__exportStar(require("./payment/types"), exports);
__exportStar(require("./account/types"), exports);
__exportStar(require("./wallet/types"), exports);
var GeneralApiErrorCodes;
(function (GeneralApiErrorCodes) {
    GeneralApiErrorCodes["RATE_LIMIT"] = "G20002";
})(GeneralApiErrorCodes = exports.GeneralApiErrorCodes || (exports.GeneralApiErrorCodes = {}));
exports.ORCHESTRATION_BASE_PATH = '/v2/orchestration';
exports.ORCHESTRATION_BASE_PATH_V3 = '/v3/orchestration';
